export const apiCreate = (): string => '/commercial/dishes/create'
export const apiList = (id?: string): string =>
  !id ? '/commercial/dishes/' : `/commercial/dishes/view/${id}`
export const apiUpdate = (id: string): string =>
  `/commercial/dishes/update/${id}`
export const apiDelete = (id: string): string =>
  `/commercial/dishes/delete/${id}`

export const apiDishesTypes = (): string => '/commercial/dishesTypes'

export const apiDishesTypesOptions = (): string =>
  '/commercial/dishesTypes/listOptions'
export const apiSearchDishesByType = (dishType: string): string =>
  `/commercial/dishes/searchByDishType?dishTypeId=${dishType}`

export const apiCreateDishesIngredients = (): string =>
  '/commercial/dishesIngredients/create'
export const apiUpdateDishesIngredients = (id: string): string =>
  `/commercial/dishesIngredients/update/${id}`
export const apiDeleteDishesIngredients = (id: string): string =>
  `/commercial/dishesIngredients/delete/${id}`
export const apiSearchIngredients = (): string =>
  '/commercial/ingredients/search'

export const apiCreateDishesImages = (): string =>
  '/commercial/dishesImages/create'
export const apiUpdateDishesImages = (id: string): string =>
  `/commercial/dishesImages/update/${id}`
export const apiDeleteDishesImages = (id: string): string =>
  `/commercial/dishesImages/delete/${id}`
